import {
	setCity,
	setKeyword,
	setRadius,
} from '@job-facets/redux/jobsFilterSlice';

function onFormSubmitted(dispatch, textSearchRef, locationRef, radiusRef) {
	// console.log(radiusRef.current.value);
	const filledKeyword = textSearchRef.current.value;
	const filledLocation = locationRef.current.value;
	const filledRadius = radiusRef.current.value;

	dispatch(setKeyword(filledKeyword));
	dispatch(setCity(filledLocation));
	dispatch(setRadius(filledRadius));
}

export default onFormSubmitted;
